/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrizeDistributionPayoutResult
 */
export interface PrizeDistributionPayoutResult {
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionPayoutResult
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionPayoutResult
     */
    teamName: string;
    /**
     * 
     * @type {number}
     * @memberof PrizeDistributionPayoutResult
     */
    place: number;
    /**
     * 
     * @type {number}
     * @memberof PrizeDistributionPayoutResult
     */
    prizeAmount: number;
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionPayoutResult
     */
    captainId: string;
    /**
     * Recipient of this row under prizeSplit EVEN_ROSTER — one row per roster member. Absent under CAPTAIN_ONLY.
     * @type {string}
     * @memberof PrizeDistributionPayoutResult
     */
    memberUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionPayoutResult
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionPayoutResult
     */
    status: PrizeDistributionPayoutResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionPayoutResult
     */
    error?: string;
}


/**
 * @export
 */
export const PrizeDistributionPayoutResultStatusEnum = {
    success: 'success',
    failed: 'failed',
    skipped: 'skipped'
} as const;
export type PrizeDistributionPayoutResultStatusEnum = typeof PrizeDistributionPayoutResultStatusEnum[keyof typeof PrizeDistributionPayoutResultStatusEnum];


/**
 * Check if a given object implements the PrizeDistributionPayoutResult interface.
 */
export function instanceOfPrizeDistributionPayoutResult(value: object): value is PrizeDistributionPayoutResult {
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('place' in value) || value['place'] === undefined) return false;
    if (!('prizeAmount' in value) || value['prizeAmount'] === undefined) return false;
    if (!('captainId' in value) || value['captainId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PrizeDistributionPayoutResultFromJSON(json: any): PrizeDistributionPayoutResult {
    return PrizeDistributionPayoutResultFromJSONTyped(json, false);
}

export function PrizeDistributionPayoutResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizeDistributionPayoutResult {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'],
        'teamName': json['teamName'],
        'place': json['place'],
        'prizeAmount': json['prizeAmount'],
        'captainId': json['captainId'],
        'memberUserId': json['memberUserId'] == null ? undefined : json['memberUserId'],
        'transactionId': json['transactionId'] == null ? undefined : json['transactionId'],
        'status': json['status'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PrizeDistributionPayoutResultToJSON(json: any): PrizeDistributionPayoutResult {
    return PrizeDistributionPayoutResultToJSONTyped(json, false);
}

export function PrizeDistributionPayoutResultToJSONTyped(value?: PrizeDistributionPayoutResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'place': value['place'],
        'prizeAmount': value['prizeAmount'],
        'captainId': value['captainId'],
        'memberUserId': value['memberUserId'],
        'transactionId': value['transactionId'],
        'status': value['status'],
        'error': value['error'],
    };
}

